import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading7.module.scss";

export const Heading7 = ({
  as = "p",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
